<template>
    <div
        :class="[
            'empty-listing-form',
            { showMap: showMap, isMobile: isMobileSize }
        ]"
    >
        <InfoForm
            :formTitle="nowLangConfig.title"
            :subTitle="nowLangConfig.subTitle"
            :showMap="showMap"
            :formList="formList"
            :submitText="nowLangConfig.submitOption.text"
            :privacyText="nowLangConfig.privacyText"
            :tag="data.tag"
            :submitStyle="{
                backgroundColor: data.submitBgColor,
                ...(nowLangConfig.submitOption.style || {})
            }"
            :condition="condition"
            :searchConfigMap="searchConfigMap"
            @done="handleShowToast"
        />
        <FormToast v-model:visible="toastVisible" v-bind="formToastOption" />
    </div>
</template>
<script>
import { mapState as rootMapState } from 'pinia';
import { usePageStore, useUserStore } from '@/store';
import InfoForm from './info-form.vue';
import FormToast from '@/components/form-toast';
import { INPUT_FIELD_MAP } from './input-tool';

import { openLoginHideOtherPop } from '@/components/sign-log';

export default {
    name: 'EmptyListing',
    components: { InfoForm, FormToast },
    i18next: {
        ns: 'md-form'
    },
    props: {
        showMap: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => {
                return {};
            }
        },
        language: {
            type: Object,
            default: () => {
                return {};
            }
        },
        condition: {
            type: String,
            default: ''
        },
        searchConfigMap: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data: function() {
        return {
            toastVisible: false
        };
    },
    computed: {
        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),
        ...rootMapState(usePageStore, {
            "currentLanguage": store => store.currentLanguage
        }),
        
        isMobileSize() {
            return this.platform.isMobile;
        },
        formToastOption() {
            const option = this.onSubmitOption;
            return this.onSubmitOption.type === 'toast'
                ? {
                    showFooter: false,
                    showMark: true,
                    content: option.toastMsg,
                    duration: option.toastDelay,
                    confirmButtonStyle: {
                        backgroundColor: this.submitBgColor
                    },
                    iconStyle: {
                        color: this.submitBgColor
                    }
                }
                : {
                    showFooter: true,
                    showMark: true,
                    content: option.destinationMsg,
                    confirmButtonText: option.buttonText,
                    confirmButtonStyle: {
                        backgroundColor: this.submitBgColor
                    },
                    iconStyle: {
                        color: this.submitBgColor
                    }
                };
        },
        nowLangConfig() {
            let baseLangConfig = {
                title: '',
                subTitle: '',
                submitOption: {},
                privacyText: ''
            };
            return {
                ...baseLangConfig,
                ...this.language[this.currentLanguage || 'en']
            };
        },
        formList() {
            return INPUT_FIELD_MAP.call(this);
        },
        onSubmitOption() {
            return {
                type: 'toast',
                toastMsg: this.nowLangConfig['toastMsg'] || '',
                url: '/',
                toastDelay: 2000
            };
        }
    },
    methods: {
        handleShowToast() {
            this.toastVisible = true;
        },
        hasUserCallBack(flag, error, value) {
            if (
                !flag && error?.code === 210003
            ) {
                setTimeout(() => {
                    openLoginHideOtherPop({}, value);
                }, 1000);
            }
        }
    }
};
</script>
<style lang="scss">
.empty-listing-form {
    max-width: 1000px;
    margin: 0 auto 60px;
    &:not(.showMap):not(.isMobile) {
        div.info-form {
            .input-content {
                .basic-info {
                    max-height: 300px;
                    flex-wrap: wrap;
                }
                .input-box:first-child {
                    margin-bottom: 20px;
                }
                .input-box + .input-box {
                    margin-bottom: 20px;
                }
                .input-box.question {
                    margin-left: 30px;
                }
            }
            form.info-form {
                position: relative;
            }
            .submit-content {
                position: absolute;
                bottom: 40px;
                right: 0;
            }
        }
    }
    div.info-form {
        padding: 30px;
        background-color: #f8f8f8;
        .form-title {
            margin-bottom: 30px;
            p + p {
                margin-top: 6px;
            }
        }
        .main-title {
            color: #000000;
            font-size: 24px;
            line-height: 1;
            font-family: var(--mg-title-font);
        }
        .subtitle {
            color: #505050;
            font-size: 16px;
            line-height: 1;
            font-family: var(--font-normal);
        }
        .input-content {
            margin-bottom: 20px;
            .basic-info {
                display: flex;
                flex-direction: column;
            }
            .input-box {
                width: calc(50% - 15px);
                .title {
                    font-family: var(--font-bold);
                    font-size: 16px;
                    line-height: 1;
                    color: #505050;
                    margin-bottom: 10px;
                    span {
                        color: #f0454c;
                    }
                }
                input,
                textarea {
                    width: 100%;
                    border: 1px solid #d5d5d5;
                    font-size: 14px;
                    line-height: 21px;
                    font-family: var(--font-normal);
                    color: #000000;
                    border-radius: 2px;
                    &::placeholder {
                        color: #c8c8c8;
                        font-size: 14px;
                        line-height: 14px;
                        font-family: var(--font-normal);
                    }
                }
                input {
                    height: 40px;
                    padding: 0 10px;
                }
                textarea {
                    height: 125px;
                    padding: 10px;
                }
            }
        }
        .submit-content {
            .submit {
                background-color: var(--g-btn-background);
                height: 40px;
                padding: 0 25px;
                line-height: 40px;
                font-size: 18px;
                color: #fff;
                font-family: var(--mg-button-font);
                border-radius: 2px;
                &.submit-disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }
            }
        }
        form.info-form {
            border-bottom: 1px solid #e6e6e6;
            margin-bottom: 35px;
        }
        .privacyText {
            color: #787878;
            font-size: 14px;
            line-height: 21px;
            font-family: var(--font-normal);
            a {
                color: var(--g-btn-background);
            }
        }
    }
    &.showMap {
        margin: 0 20px 60px;
        div.info-form {
            padding: 20px 30px 30px;
            .main-title {
                font-size: 20px;
            }
            .input-content {
                .input-box {
                    width: 100%;
                }
                .input-box + .input-box {
                    margin-top: 20px;
                }
            }
            .submit-content {
                .submit {
                    margin-bottom: 30px;
                }
            }
            form.info-form {
                margin-bottom: 30px;
            }
        }
    }
    &.isMobile {
        margin-bottom: 30px;
        div.info-form {
            padding: 20px;
            .form-title {
                margin-bottom: 20px;
            }
            .main-title {
                font-size: 16px;
            }
            .subtitle {
                font-size: 14px;
            }
            .input-content {
                .input-box {
                    width: 100%;
                }
                .input-box + .input-box {
                    margin-top: 20px;
                }
            }
            .submit-content {
                .submit {
                    width: 100%;
                    margin-bottom: 20px;
                }
            }
            form.info-form {
                margin-bottom: 20px;
            }
        }
    }
}
</style>
